export const formatAmountIndian = (value) => {
  if (value == null || isNaN(value)) return "-";

  const num = Number(value);

  if (num >= 10000000) {
    return `${(num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1)}Cr`;
  }

  if (num >= 100000) {
    return `${(num / 100000).toFixed(num % 100000 === 0 ? 0 : 1)}L`;
  }

  return num.toLocaleString("en-IN");
};
